/**
 * Identifies a call by a unique callId and callNumber.
 * @summary We used to only identifiy calls by callId, but we need to identify them by callNumber as well since the number of a call changes during attended transfers.
 */
class CallIdAndNumber {
    private readonly callId: string;
    private readonly callNumber: string;

    constructor(callId: string, callNumber: string) {
        Object.assign(this, { callId, callNumber });
    }

    public get CallId(): string {
        return this.callId;
    }

    public get CallNumber(): string {
        return this.callNumber;
    }

    public Equals(other: CallIdAndNumber | null): boolean {
        return this.callId === other?.callId && this.callNumber === other?.callNumber;
    }
}

export { CallIdAndNumber };
